const isCardExpired = (expirationDate: string) => {
  const expiration = expirationDate.split('/');
  const currentDate = new Date();
  const currentYear = Number(
    currentDate
      .getFullYear()
      .toString()
      .substr(-2)
  );
  const givenYear = Number(expiration[1]);
  if (givenYear === currentYear) {
    return Number(expiration[0]) < currentDate.getMonth() + 1;
  }
  return givenYear < currentYear;
};

export default isCardExpired;
